import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Injectable({
  providedIn: 'root'
})
export class SentryService {

  constructor() { }

  /**
   * Captures an exception and reports it to Sentry.
   * @param error The error object to capture.
   * @param context Optional additional context (tags or extra data).
   */
  captureException(error: any, context?: { [key: string]: any }) {
    Sentry.withScope((scope) => {
      if (context) {
        Object.entries(context).forEach(([key, value]) => {
          scope.setExtra(key, value);
        });
      }
      Sentry.captureException(error);
    });
  }

  /**
   * Captures a manual message and reports it to Sentry.
   * @param message The message to report.
   * @param level Severity level (info, warning, error, etc.)
   */
  captureMessage(message: string, level: Sentry.SeverityLevel = 'info') {
    Sentry.captureMessage(message, level);
  }

  /**
   * Adds a breadcrumb to the current Sentry session.
   * @param breadcrumb The breadcrumb object.
   */
  addBreadcrumb(breadcrumb: Sentry.Breadcrumb) {
    Sentry.addBreadcrumb(breadcrumb);
  }

  /**
   * Sets user context for the reported events.
   * @param user User object containing id, email, username, etc.
   */
  setUser(user: Sentry.User | null) {
    Sentry.setUser(user);
  }
}
